export const text = {
  HR: "HR",
  HolidayList: "Holiday List",
  LeavePolicy: "Leave Policy",
  LeaveAllocation: "Leave Allocation",
  LeaveType: "Leave Type",
  AllocatedLeaves: "Allocated Leaves",
  UsedLeaves: "Used Leaves",
  BalanceLeave: "Balance Leave",
  ValidFrom: "Valid From",
  ValidTo: "Valid To",
  Leaverequests: "Leave requests",
  NewLeaverequest: "New Leave request",
  Type: "Type",
  HalfDayDate: "Half Day Date",
  CompensatoryAllocation: "Compensatory Allocation",
  ReportRecover: "Report Recover",
  LeaveRequestDeletedsuccessfully: "Leave Request Deleted successfully",
  LeaveRequestupdatedsuccessfully: "Leave Request updated successfully",
  LeaveRequestcancelledsuccessfully: "Leave Request cancelled successfully",
  Leavemarkedasrecoveredsuccessfully: "Leave marked as recovered successfully",
  Areyousureyouwantto: "Are you sure you want to",
  this: "this",
  Enterrecovereddate: "Enter recovered date",
  ToDate: "To Date",
  Leaveallocatedsuccessfully: "Leave allocated successfully.",
  FromDate: "From Date",
  LeaveAllocationupdatedsuccessfully: "Leave Allocation updated successfully",
  NewLeavesAllocated: "New Leaves Allocated",
  Addunusedleavesfrompreviousallocations:
    "Add unused leaves from previous allocations",
  TotalLeavesAllocated: "Total Leaves Allocated",
  Unusedleaves: "Unused leaves",
  LeaveRequest: "Leave Request",
  Leaverequestapplysuccessfully: "Leave request apply successfully",
  Reason: "Reason",
  AddHoliday: "Add Holiday",
  Leaveoverview: "Leave overview",
  AbsenceOverview: "Absence Overview",
  Agenda: "Agenda",
  HolidayListName: "Holiday List Name",
  Holiday: "Holiday",
  AddHolidayList: "Add Holiday List",
  AddLeaveType: "Add Leave Type",
  AddLeavePolicy: "Add Leave Policy",
  LeavePolicies: "Leave Policies",
  OptionalHolidays: "Optional Holidays",
  Name: "Name",
  TotalHolidays: "Total Holidays",
  Description: "Description",
  HolidayDate: "Holiday Date",
  description: "description",
  AddWeeklyHoliday: "Add Weekly Holiday",
  Holidays: "Holidays",
  LeaveTypeupdatedsuccessfully: "Leave Type updated successfully",
  CarryForward: "Carry Forward",
  LeaveWithoutPay: "Leave Without Pay",
  OptionalLeave: "Optional Leave",
  Compensatory: "Compensatory",
  LeaveTypeaddedsuccessfully: "Leave Type added successfully",
  LeaveTypeName: "Leave Type Name",
  MaximumConsecutiveLeavesAllowed: "Maximum Consecutive Leaves Allowed",
  CarryForward: "Carry Forward",
  MaximumCarryForwardedLeaves: "Maximum Carry Forwarded Leaves",
  ExpireCarryForwardedLeavesDays: "Expire Carry Forwarded Leaves (Days)",
  AllocateonDay: "Allocate on Day",
  FirstDay: "First Day",
  LastDay: "Last Day",
  DateofJoining: "Date of Joining",
  IsCarryForward: "Is Carry Forward",
  IsLeaveWithoutPay: "Is Leave Without Pay",
  IsOptionalLeave: "Is Optional Leave",
  AllowOverAllocation: "Allow Over Allocation",
  Allowsallocatingmoreleavesthanthenumberofdaysintheallocationperiod:
    "Allows allocating more leaves than the number of days in the allocation period.",
  IsCompensatory: "Is Compensatory",
  IsEarnedLeave: "Is Earned Leave",
  IsSickLeave: "Is Sick Leave",
  LeavePolicyaddedsuccessfully: "Leave Policy added successfully",
  LeaveTypes: "Leave Types",
  AnnualAllocation: "Annual Allocation",
  addunusedleavesfrompreviousallocations:
    "add unused leaves from previous allocations",
  LeaveTypeList: "Leave Type List",
  AddLeavePolicyDetails: "Add Leave Policy Details",
  LeaveSettings: "Leave Settings",
  Period: "Period",
  approve: "approve",
  reject: "reject",
  Leavecancelledsuccessfully: "Leave cancelled successfully",
  Explanation: "Explanation",
  CompensatoryLeaveRequestupdatedsuccessfully:
    "Compensatory Allocation Request updated successfully",
  TotalDuration: "Total Duration",
  CompensatoryAllocationRequest: "Compensatory Allocation Request",
  LeaveBlockList: "Leave Block List",
  AddLeaveBlockList: "Add Leave Block List",
  LeaveBlockListName: "Leave Block List Name",
  BlockDays: "Block Days",
  AddDaywiseDates: "Add Day-wise Dates",
  LeaveBlockListDates: "Leave Block List Dates",
  BlockDate: "Block Date",
  AddBlockDay: "Add Block Day",
  StopusersfrommakingLeaveApplicationsonfollowingdays:
    "Stop users from making Leave Applications on following days",
  AddLeaveBlockDates: "Add Leave Block Dates",
  Leaveblocklistname: "Leave block list name",
  Pleaseselectdays: "Please select days",
  LeaveBlockListaddedsuccessfully: "Leave Block List added successfully",
  LeaveBlockListupdatedsuccessfully: "Leave Block List updated successfully",
  AddFolder: "Add Folder",
  AddDocument: "Add Document",
  Mydocuments: "My documents",
  Folderaddedsuccessfully: "Folder added successfully",
  Folder: "Folder",
  FileName: "File Name",
  Documentaddedsuccessfully: "Document added successfully",
  Documentupdatedsuccessfully: "Document updated successfully",
  SelectDocument: "Select Document",
  Sharewithemployee: "Share with employee",
  Folderupdatedsuccessfully: "Folder updated successfully",
  FolderDeletedsuccessfully: "Folder Deleted successfully",
  EmptyFolder: "Empty Folder",
  EditDocument: "Edit Document",
  EditFolder: "Edit Folder",
  Documentdeletedsuccessfully: "Document deleted successfully",
  HalfDay: "Half Day",
};
